import { Box, useTheme } from "@mui/material";
import React from "react";
export const HorizontalScrollList = ({ children, items = 2.35, ordered = false, sx = {}, }) => {
    const theme = useTheme();
    const [itemWidth, setItemWidth] = React.useState(200);
    React.useEffect(() => {
        if (typeof window === "undefined")
            return;
        const padding = items * 1.5 * 16;
        const itemWidth = (window.innerWidth - padding) / (items - 0.8);
        setItemWidth(itemWidth);
    }, [items, setItemWidth]);
    return (React.createElement(Box, { component: ordered ? "ol" : "ul", sx: {
            "::-webkit-scrollbar": { width: "0px" },
            display: "flex",
            listStyleType: "none",
            my: -6,
            overflowX: "scroll",
            overscrollBehaviorX: "none",
            px: 0,
            py: 6,
            scrollbarWidth: "none",
            WebkitOverflowScrolling: "auto",
            width: "100%",
            "::after": {
                borderRightColor: "transparent",
                borderRightStyle: "solid",
                borderRightWidth: theme.spacing(3),
                content: "''",
                display: "block",
            },
            li: {
                "&:first-of-type": { ml: 3 },
                "&:last-of-type": { mr: 0 },
                flexShrink: 0,
                mx: 2,
                width: `${itemWidth}px`,
            },
            ...sx,
        } }, children));
};
//# sourceMappingURL=horizontal-scroll-list.js.map